exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".quizReview .spacedButton{margin-left:15px}.quizReview .scoreText{margin-top:15px;margin-left:10px}.quizReview .firstButton{margin-left:10px}.quizReview .cancelButton{margin-top:10px}.quizReview .overrideControls{margin-top:15px;margin-left:15px;display:inline-block;overflow-x:auto;width:100%;white-space:nowrap;overflow:hidden}.quizReview .buttons{margin-top:10px}.quizReview .spinnerBox{margin:auto;width:60%;padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/quizzes/quiz_review.scss
// module id = 1533
// module chunks = 0